import React from "react";
import { UserWrapper, FeedbackWrapper, BookmarkWrapper } from "./src/contexts";
import Layout from "./src/components/Layout";

export const wrapRootElement = ({ element }) => {
  return (
    <UserWrapper>
      <FeedbackWrapper>
        <BookmarkWrapper>
          <Layout>{element}</Layout>
        </BookmarkWrapper>
      </FeedbackWrapper>
    </UserWrapper>
  );
};
